import request from "../../Frontends/Common/utils/request/requestMain";
const _ = require("lodash");
const rootRoute = "/addressprogram/addressprogramorder/";

export default class AddressProgramOrderApi {
  constructor() {
    this.defaultModel = {
    };
  }
  async getAddressProgramOrders(params, data) {
    return await request.post(`${rootRoute}getAddressProgramOrders`, {
      filter: params,
      data: data,
    });
  }
  async getAddressProgramOrder(id) {
    return await request.post(`${rootRoute}getAddressProgramOrders`, {
      filter: `$filter=Id eq ${id}`,
      parameters: {},
      data: []
    });
  }
  async getAddressProgramOrdersCount(params) {
    return await request.post(`${rootRoute}getAddressProgramOrdersCount`, {
      filter: params
    });
  }
  async getAddressProgramOrdersStatusCount(params) {
    return await request.post(`${rootRoute}getAddressProgramOrdersStatusCount`, {
      filter: params
    });
  }
  async createAddressProgramOrder(model) {
    const data = [_.merge(_.cloneDeep(this.defaultModel), model)];
    return await request.post(`${rootRoute}createAddressProgramOrder`, { data });
  }
  async deleteAddressProgramOrder(model) {
    const data = [model];
    return await request.post(`${rootRoute}deleteAddressProgramOrder`, { data });
  }
  async editAddressProgramOrder(model) {
    const data = [_.merge(_.cloneDeep(this.defaultModel), model)];
    return await request.post(`${rootRoute}updateAddressProgramOrder`, { data });
  }
  async updateAddressProgramOrderCoAdmin(model) {
    const data = [_.merge(_.cloneDeep(this.defaultModel), model)];
    return await request.post(`${rootRoute}updateAddressProgramOrderCoAdmin`, { data });
  }
  async updateAddressProgramOrderCoSupervisor(model) {
    const data = [_.merge(_.cloneDeep(this.defaultModel), model)];
    return await request.post(`${rootRoute}updateAddressProgramOrderCoSupervisor`, { data });
  }
  async updateAddressProgramOrderAgency(model) {
    const data = [_.merge(_.cloneDeep(this.defaultModel), model)];
    return await request.post(`${rootRoute}updateAddressProgramOrderAgency`, { data });
  }
  async import(gfid, marsPeriod) {
    return await request.post(`${rootRoute}importAddressProgramOrder`, {
      gfid: gfid,
      marsPeriod: marsPeriod
    });
  }
  async importKPIPlan(gfid, marsPeriod) {
    return await request.post(`${rootRoute}importAddressProgramOrderKPIPlan`, {
      gfid: gfid,
      marsPeriod: marsPeriod
    });
  }
  async importKPIFact(gfid, marsPeriod) {
    return await request.post(`${rootRoute}importAddressProgramOrderKPIFact`, {
      gfid: gfid,
      marsPeriod: marsPeriod
    });
  }
  async importBudgetFact(gfid, marsPeriod) {
    return await request.post(`${rootRoute}importAddressProgramOrderBudgetFact`, {
      gfid: gfid,
      marsPeriod: marsPeriod
    });
  }
  async importAgencyTerritory(gfid, marsPeriod) {
    return await request.post(`${rootRoute}importAgencyTerritory`, {
      gfid: gfid,
      marsPeriod: marsPeriod
    });
  }
  async getImportScaffold(scaffoldType) {
    return await request.post(`${rootRoute}getAddressProgramOrderimporttemplate`, {
      templateType: scaffoldType
    }, {responseType: 'blob'});
  }
  async export(filter, format) {
    return await request.post(`${rootRoute}exportAddressProgramOrder`, {
      filter: filter,
      format: format
    });
  }
  async getOrdersStatusCount(params) {
    return await request.post(`${rootRoute}getOrdersStatusCount`, {
      filter: params,
      parameters: {},
    });
  }
  async getAddressProgramAgencyStatusCount(params) {
    return await request.post(`${rootRoute}getAddressProgramAgencyStatusCount`, {
      filter: params
    });
  }
  async copyAgencyTerritory(marsPeriod) {
    return await request.post(`${rootRoute}copyAgencyTerritoryFromThePastPeriod`, {
      marsPeriodId: marsPeriod
    });
  }
  async updateMultipleAddressProgramOrderAgency(data) {
    return await request.post(`${rootRoute}updateMultipleAddressProgramOrderAgency`, { data });
  }
  
}
